import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getEditorContent } from "../../../services/apiEditor";

export function useLoadEditorContent(proposal_id, search_type) {
  return useQuery({
    queryKey: ["editorContent", proposal_id, search_type],
    queryFn: () => getEditorContent(proposal_id, search_type),
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
